<template>
  <main>
    <h3 class="text-center m-0 p-4 header">
      {{ patientInfo.hospital_name }}
      <br>
      {{ title }}
    </h3>
    <van-cell-group class="mb-3">
      <van-cell
        :value="patientInfo.image_id"
        title="检查编号" />
      <van-cell
        :value="patientInfo.patient_name"
        title="姓名" />
      <van-cell
        :value="patientInfo.age"
        title="年龄" />
      <van-cell
        :value="patientInfo.gender"
        title="性别" />
    </van-cell-group>
    <van-cell-group class="mb-3">
      <van-cell
        :label="patientInfo.check_item"
        title="检查部位" />
      <van-cell
        :label="imageInfo.examination_report"
        title="检查所见" />
      <van-cell
        :label="imageInfo.examination_show"
        title="诊断所得" />
    </van-cell-group>
    <van-cell-group class="mb-3">
      <van-cell
        :value="patientInfo.submitter_name"
        title="报告医生" />
      <van-cell
        :value="submitTime"
        title="报告日期" />
      <van-cell
        v-if="title === '放射报告单'"
        :value="patientInfo.assessor_name"
        title="审核医生" />
      <van-cell
        v-if="title === '放射报告单'"
        :value="assessTime"
        title="审核日期" />
    </van-cell-group>
    <div
      v-show="loading"
      class="mask">
      <van-loading
        class="position-fixed"
        style="top: calc(50% - 15px); left: calc(50% - 15px);"/>
    </div>
  </main>
</template>

<script>
import format from 'date-fns/format';

export default {
  name: 'FilmTabsReport',
  props: {
    loading: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: '放射报告单',
    },
    patientInfo: {
      type: Object,
      required: true,
      default() {
        return {
          hospital_name: '',
          image_id: '',
          patient_name: '',
          gender: '',
          age: '',
          submit_time: '',
        };
      },
    },
    imageInfo: {
      type: Object,
      required: true,
      default() {
        return {
          examination_report: '',
          examination_show: '',
        };
      },
    },
  },
  computed: {
    submitTime() {
      const time = this.patientInfo.submit_time;
      if (time) {
        return format(time, 'YYYY-MM-dd');
      }
      return '';
    },
    assessTime() {
      if (this.patientInfo.assess_time) {
        return format(this.patientInfo.assess_time, 'YYYY-MM-dd');
      }
      return '';
    },
  },
};
</script>

<style scoped>
.header {
  background-color: #fff;
}
.mask {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.87);
  z-index: 999;
}
</style>
